/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Friends_SinceInputs */

const en_friends_since = /** @type {(inputs: Friends_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Since ${i?.date}`)
};

const de_friends_since = /** @type {(inputs: Friends_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seit ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Since {date}" |
*
* @param {Friends_SinceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const friends_since = /** @type {((inputs: Friends_SinceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Friends_SinceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_friends_since(inputs)
	return en_friends_since(inputs)
});